import { render } from "./VcnContent.vue?vue&type=template&id=c6f539ce"
import script from "./VcnContent.vue?vue&type=script&lang=js"
export * from "./VcnContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__